import type { Clock } from '../core/types';

export class BrowserClock implements Clock {
  public now(): number {
    return performance.now();
  }

  public requestFrame(callback: FrameRequestCallback): number {
    return window.requestAnimationFrame(callback);
  }

  public cancelFrame(handle: number): void {
    window.cancelAnimationFrame(handle);
  }
}
